export type LibraryBrowseBaseRoute = '/main/home/files' | '/main/home/dept-assets';

/**
 * Maps folder library type to the file manager base route.
 * 1 = Personal (My Files), 2 = Department (Department Assets / Org Assets UI).
 * Unknown/null defaults to dept-assets (legacy activity-open behaviour).
 */
export function getLibraryBrowseBaseRoute(libraryType: number | null | undefined): LibraryBrowseBaseRoute {
  return Number(libraryType) === 1 ? '/main/home/files' : '/main/home/dept-assets';
}
